import { KatapultElement, html } from '../../mixins/katapult-element';
// import '../../style-modules/paper-dialog-style';
// import '../../style-modules/paper-table-style';
import '../style-modules/katapult-scrollbars';
import '../style-modules/flex';
import '../material-icon/material-icon';
import '../katapult-frame/katapult-frame';
import '../service-slot/service-slot';
import { DialogService } from '../../modules/DialogService.js';
import { GetEventCoords } from '../../modules/GetEventCoords.js';
import { Clamp } from '../../modules/Clamp.js';
import { ColorPropertyObserver } from '../../modules/ColorPropertyObserver.js';

class KatapultDialogLegacy extends KatapultElement {
  static get template() {
    return html`
      <style include="flex katapult-scrollbars">
        :host {
          display: flex;
          flex-direction: column;
          position: fixed;
          z-index: 999;
          background: white;
          border-radius: 16px;
          font-family: Roboto;
          width: fit-content;
          @apply --shadow-elevation-8dp;
        }
        :host(:not([opened])) {
          pointer-events: none;
          opacity: 0;
          transform: translateY(24px) scale(0.98);
        }
        [hidden] {
          display: none !important;
        }
        #header {
          /* display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center; */
          font-size: 14pt;
          border-radius: inherit;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;

          background: var(--katapult-dialog-legacy-background-color);
          color: var(--katapult-dialog-legacy-color);
          padding: 16px;
          gap: 8px;
        }
        :host([red]) #header {
          background: var(--paper-red-500);
        }

        slot[name='title'][uppercase] {
          text-transform: uppercase;
        }

        slot[name='subtitle'] {
          font-size: 12pt;
          font-weight: lighter;
          text-transform: initial;
        }

        ::slotted([slot='subtitle']) {
          margin-top: 6px;
        }

        ::slotted([slot='icon']),
        slot[name='icon'] material-icon {
          /* margin-right: 6px; */
          padding: 0;
        }

        #bodyWrapper {
          position: relative;
          overflow: hidden;
        }

        #body {
          overflow: auto;
          display: flex;
          flex-direction: column;
          padding: 16px;
          @apply --katapult-dialog-legacy-body;
        }

        #scrollShadowTop,
        #scrollShadowBottom {
          position: absolute;
          left: 0;
          height: 16px;
          width: 100%;
          pointer-events: none;
          z-index: 1;
        }

        #scrollShadowTop {
          top: 0;
          background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));
        }

        #scrollShadowBottom {
          bottom: 0;
          background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1));
        }

        #buttons {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding: 8px;
          margin-top: 8px;
        }

        #buttons[hidden] {
          display: none;
        }

        :host([draggable]) #header {
          cursor: grab;
        }
      </style>
      <div id="header" flex align-center hidden$="[[noHeader]]">
        <template is="dom-if" if="[[draggable]]">
          <material-icon faded icon="drag_indicator"></material-icon>
        </template>
        <slot name="header-left"></slot>
        <div spacer></div>
        <slot name="icon">
          <template is="dom-if" if="[[icon]]">
            <material-icon icon="[[icon]]"></material-icon>
          </template>
        </slot>
        <div flex column align-center>
          <div flex align-center>
            <slot name="title">
              <template is="dom-if" if="[[title]]">
                <span>[[title]]</span>
              </template>
            </slot>
          </div>
          <div flex align-center>
            <slot name="subtitle">
              <template is="dom-if" if="[[subtitle]]">
                <span>[[subtitle]]</span>
              </template>
            </slot>
          </div>
        </div>
        <div spacer></div>
        <slot name="header-right"></slot>
        <template is="dom-if" if="[[manuallyPositioned]]">
          <material-icon icon="settings_overscan" on-click="resetPosition" pointer></material-icon>
          <!-- TODO: Replace with <material-icon-button></material-icon-button> -->
        </template>
        <!-- TODO (06-21-2022): This is temporary, used by chat -->
        <div id="headerButtons">
          <slot name="headerButtons"></slot>
        </div>
        <template is="dom-if" if="[[closeButton]]">
          <material-icon icon="close" on-click="close" pointer></material-icon>
          <!-- TODO: Replace with <material-icon-button></material-icon-button> -->
        </template>
      </div>
      <div id="bodyWrapper" flex column>
        <div id="scrollShadowTop"></div>
        <div id="scrollShadowBottom"></div>
        <div id="body" on-scroll="_updateShadow">
          <slot name="body"></slot>
        </div>
      </div>
      <div id="buttons" hidden$="[[!_hasButtons]]">
        <slot name="buttons" on-slotchange="_buttonSlotChangeHandler"></slot>
      </div>
    `;
  }
  static get properties() {
    return {
      backdrop: {
        type: Boolean,
        value: false
      },
      closeButton: {
        type: Boolean,
        value: false
      },
      color: {
        type: String,
        value: 'var(--secondary-color)'
      },
      draggable: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      dragging: {
        type: Boolean,
        value: false,
        notify: true,
        readOnly: true
      },
      dynamicResize: {
        type: Boolean,
        value: false
      },
      fitInto: {
        type: Element,
        value: window
      },
      icon: {
        type: String
      },
      manuallyPositioned: {
        type: Boolean,
        value: false,
        notify: true,
        readOnly: true
      },
      maxHeight: {
        type: Number
      },
      maxWidth: {
        type: Number
      },
      minHeight: {
        type: Number,
        value: 100
      },
      minWidth: {
        type: Number,
        value: 300
      },
      modal: {
        type: Boolean,
        value: false
      },
      noCancelOnEscKey: {
        type: Boolean,
        value: false
      },
      noCancelOnOutsideClick: {
        type: Boolean,
        value: false
      },
      noHeader: {
        type: Boolean,
        value: false
      },
      opened: {
        type: Boolean,
        value: false,
        notify: true,
        reflectToAttribute: true
      },
      padding: {
        type: Number,
        value: 24
      },
      persistManualPosition: {
        type: Boolean,
        value: false
      },
      serviceSlot: {
        type: Boolean,
        value: false
      },
      subtitle: {
        type: String
      },
      title: {
        type: String
      },
      transitionSpeed: {
        type: Number,
        value: 0.3
      },
      uppercase: {
        type: Boolean,
        value: false
      },
      _bounds: {
        // Min Max XY values for the dialog.
        type: Object,
        readOnly: true
      },
      _dragCoords: {
        type: Object,
        readOnly: true
      },
      _dragOffset: {
        // Offset between dialog top-left corner and inital manual drag click point.
        type: Object,
        readOnly: true
      },
      _dragStartBounds: {
        type: Object,
        readOnly: true
      },
      _fitInto: {
        type: Element,
        readOnly: true,
        value: window
      },
      _fitIntoBounds: {
        // Min Max XY values for the region in which the dialog may be positioned.
        type: Object,
        readOnly: true
      },
      _fitIntoRect: {
        type: DOMRect,
        readOnly: true
      },
      _hasButtons: {
        type: Boolean,
        value: false
      },
      _mousedDownOnDialog: {
        type: Boolean,
        value: false,
        readOnly: true
      },
      _mouseDownButton: {
        type: Element,
        readOnly: true
      },
      _rect: {
        type: DOMRect,
        readOnly: true
      },
      _targetCoords: {
        type: Object,
        readOnly: true
      }
    };
  }

  static get observers() {
    return [
      '_openedChanged(opened)',
      '_resize(_bounds, _fitIntoBounds, _dragCoords, minHeight, minWidth)',
      '_updateBounds(_rect)',
      '_updateFitInto(fitInto)',
      '_updateFitIntoBounds(_fitIntoRect, padding)',
      '_updateKeydownHandler(opened, noCancelOnEscKey)',
      '_updateShadow(_bounds)',
      '_updateTransition(transitionSpeed, _dragCoords, _transitionAll, dynamicResize, initialized)'
    ];
  }

  get transitionMillis() {
    return this.transitionSpeed * 1000;
  }

  constructor() {
    super();

    // Prevent default tooltip from showing.
    this.removeAttribute('title');

    // Initialize global z-index property.
    window._openedKatapultDialogLegacys ??= new Set();

    this._keydownHandler = function (e) {
      if (e.key == 'Escape' && !this.noCancelOnEscKey) this.close();
    }.bind(this);

    this._mouseDownHandler = function (e) {
      e.stopPropagation();
      // Determine if the click originated from or within the drag handle.
      let dragZone = e.composedPath().some((x) => x == this.$.header);
      // If click came from drag handle, begin to drag the dialog.
      if (this.draggable && dragZone) {
        let coords = GetEventCoords(e);
        let rect = this._calcRect(this);
        if (!this._dragStartBounds) this._set_dragStartBounds(this._calcBounds(rect));
        this._set_dragOffset({
          x: this._targetCoords.x - coords.clientX,
          y: this._targetCoords.y - coords.clientY
        });
        // Attach mouse move handlers.
        window.addEventListener('mousemove', this._mouseMoveHandler);
        window.addEventListener('touchmove', this._mouseMoveHandler);
      }
      // Store whether or not the event occurred on the dialog.
      this._set_mousedDownOnDialog(e.composedPath().some((x) => x == this));
      // Store the button the event occurred within if there is one.
      this._set_mouseDownButton(e.composedPath().find((x) => x.tagName?.includes('BUTTON')));
    }.bind(this);

    this._mouseUpHandler = function (e) {
      e.stopPropagation();
      // Remove mouse move handlers.
      window.removeEventListener('mousemove', this._mouseMoveHandler);
      window.removeEventListener('touchmove', this._mouseMoveHandler);
      // Clear dragging flag.
      this._setDragging(false);
      // See if the user clicked outside of the dialog (starting and ending off of the dialog).
      let mouseUpOnDialog = e.composedPath().some((x) => x == this);
      let outsideClick = !mouseUpOnDialog && !this._mousedDownOnDialog;
      // See if the user clicked a button (starting and ending on the same button).
      let mouseUpButton = e.composedPath().find((x) => x.tagName?.includes('BUTTON'));
      let dialogButtonClick =
        this.contains(mouseUpButton) &&
        mouseUpButton == this._mouseDownButton &&
        ['dialog-dismiss', 'dialog-confirm'].some((attr) => mouseUpButton.hasAttribute(attr));
      // Close the dialog if we clicked outside or an applicable button was pressed.
      if ((outsideClick && !this.noCancelOnOutsideClick && DialogService._records.slice(-1)[0]?.dialog == this) || dialogButtonClick)
        this.close(dialogButtonClick ? mouseUpButton : undefined);
    }.bind(this);

    this._mouseMoveHandler = function (e) {
      e.stopPropagation();
      // Set drag coordinates.
      this._set_dragCoords(GetEventCoords(e));
      // Set dragging flag.
      this._setDragging(true);
      // Set manually positioned flag.
      this._setManuallyPositioned(true);
    }.bind(this);

    this._resizeHandler = function (e) {
      if (this._fitInto == window) this._set_fitIntoRect(this._calcRect(this._fitInto));
    }.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();

    // Build resize observer and observe this element.
    this._resizeObserver ??= new ResizeObserver((entries) => {
      // For some reason, entry.contentRect doesn't give top and left relative to the viewport even though it is supposed to?
      for (let entry of entries) {
        // Handle dialog size changing.
        if (entry.target == this) {
          this._set_rect(entry.contentRect);
        }
        // Handle _fitInto size changing.
        else if (entry.target == this._fitInto) {
          this._set_fitIntoRect(this._calcRect(entry.target));
        }
      }
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('keydown', this._keydownHandler);

    this._resizeObserver?.disconnect();
    this._resizeObserver = null;
  }

  ready() {
    super.ready();

    // Setup the color property observer.
    ColorPropertyObserver(this);

    // Set modal flags.
    if (this.modal) {
      this.backdrop = true;
      this.noCancelOnEscKey = true;
      this.noCancelOnOutsideClick = true;
    }

    // Set backdrop flags.
    if (this.backdrop) {
      this.serviceSlot = true;
    }

    // Setup service slot.
    if (this.serviceSlot) {
      const serviceSlot = document.createElement('service-slot');
      serviceSlot.id = this.id;
      serviceSlot.name = 'dialog';
      this.parentNode.insertBefore(serviceSlot, this);
      serviceSlot.appendChild(this);
    }

    // Set initialized flag.
    this.initialized = true;
  }

  _buttonSlotChangeHandler(e) {
    let elements = Array.from(e.currentTarget.assignedNodes()).filter((node) => node.nodeType == Node.ELEMENT_NODE);
    this._hasButtons = elements.length > 0;
  }

  clearButtons() {
    // TODO: Super hacky, redo this generally as part of katapult-element.
    let temp = (elem) => {
      const root = elem.shadowRoot ?? elem;
      if (!root?.querySelectorAll) return [];
      const elements = Array.from(root.querySelectorAll('katapult-button,slot'));
      const matches = [];
      elements.forEach((elem) => {
        if (elem.tagName == 'katapult-button') matches.push(elem);
        else if (elem.tagName == 'SLOT') {
          elem.assignedNodes().forEach((elem) => matches.push(...temp(elem)));
        }
      });
      return matches;
    };

    // Find all instances of katapult-button within the dialog and clear them.
    const buttons = temp(this);

    buttons.forEach((button) => button.clear());
  }

  delayedClose(delay = 500) {
    this.close({ delay });
  }

  /**
   * Close (hide) the katapult dialog
   * @param {Object} details - data with which to resolve the dialog's promise
   */
  close(details) {
    // Fire event that the dialog is closing.
    this.dispatchEvent(new CustomEvent('closing'));
    this.closing = true;

    setTimeout(() => {
      this._closingDetails = details;
      this.opened = false;
    }, details?.delay ?? 0);
  }

  /**
   * Open (show) the katapult dialog
   * @returns promise that resolves with the dialog button clicked (or undefined)
   */
  async open() {
    this.opened = true;
    return this._getPromise();
  }

  get confirmButton() {
    return this.querySelector('[button-confirm], [dialog-confirm]');
  }

  setPosition(clientX, clientY) {
    let rect = this._calcRect(this);
    if (!this._dragStartBounds) this._set_dragStartBounds(this._calcBounds(rect));
    this._set_dragOffset({
      x: this._targetCoords.x,
      y: this._targetCoords.y
    });
    // Set drag coordinates.
    this._set_dragCoords({ clientX, clientY });
    // Set manually positioned flag.
    this._setManuallyPositioned(true);
  }

  resetPosition() {
    if (this._setManuallyPositioned) {
      this._transitionAll = true;
      setTimeout(() => (this._transitionAll = false), this.transitionSpeed * 1000);
    }
    this._setManuallyPositioned(false);
    this._set_dragStartBounds(null);
    this._set_dragCoords(null);
    this._set_dragOffset(null);
  }

  _calcBounds(rect, options) {
    options = options || { padding: 0 };
    if (rect)
      return {
        xMin: rect.left + options.padding,
        xMax: rect.left + rect.width - options.padding,
        yMin: rect.top + options.padding,
        yMax: rect.top + rect.height - options.padding,
        height: rect.height - options.padding * 2,
        width: rect.width - options.padding * 2
      };
  }
  _calcRect(elem) {
    if (elem instanceof Element) return elem.getBoundingClientRect();
    else if (elem == window)
      return {
        bottom: window.innerHeight,
        height: window.innerHeight,
        left: 0,
        right: window.innerWidth,
        top: 0,
        width: window.innerWidth,
        x: 0,
        y: 0
      };
  }
  _getPromise() {
    // If the promise doesn't already exist, create it
    if (this._promise == null) {
      this._promise = new Promise((res) => (this._promiseResolve = res));
      this._promise.finally(() => {
        this._promiseResolve = null;
        this._promise = null;
      });
    }
    return this._promise;
  }
  _openedChanged() {
    if (this.opened) {
      // Fire event that the dialog is opening.
      this.dispatchEvent(new CustomEvent('opening'));

      // Observe dialog size changes.
      this._resizeObserver.observe(this);

      // Observe _fitInto size changes.
      this._set_fitIntoRect(this._calcRect(this._fitInto));
      if (this._fitInto instanceof Element) this._resizeObserver.observe(this._fitInto);
      else if (this._fitInto == window) window.addEventListener('resize', this._resizeHandler);

      // Attach click event listener.
      window.addEventListener('mousedown', this._mouseDownHandler);
      window.addEventListener('touchstart', this._mouseDownHandler);
      window.addEventListener('mouseup', this._mouseUpHandler);
      window.addEventListener('touchend', this._mouseUpHandler);

      // Clear success/failure states on buttons.
      this.clearButtons();

      // Register the dialog with Dialog Service.
      const { zIndex } = DialogService.register(this);

      // Update the z-index of this dialog.
      this.style.zIndex = zIndex;

      if (this.timeout) window.clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        // Fire event that the dialog has opened.
        this.dispatchEvent(new CustomEvent('opened'));
      }, this.transitionSpeed * 1000);
    } else {
      // Fire event that the dialog is closing.
      if (!this.closing) this.dispatchEvent(new CustomEvent('closing'));

      // Set closing flag.
      this.closing = true;

      // Remove click event listener.
      window.removeEventListener('mousedown', this._mouseDownHandler);
      window.removeEventListener('touchstart', this._mouseDownHandler);
      window.removeEventListener('mouseup', this._mouseUpHandler);
      window.removeEventListener('touchend', this._mouseUpHandler);
      window.removeEventListener('resize', this._resizeHandler);

      // Unregister the dialog with Dialog Service.
      DialogService.unregister(this);

      if (this.timeout) window.clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        // Reset the dialog's position unless we are persisting manual position.
        if (!this.persistManualPosition) this.resetPosition();

        // Fire event that the dialog has closed.
        this.dispatchEvent(new CustomEvent('closed'));

        // Clear the closing flag.
        this.closing = false;
      }, this.transitionMillis);

      // Get closing details and resolve the promise.
      const details = this._closingDetails;
      this._closingDetails = null;
      this._promiseResolve?.(details);
    }
  }
  _resize() {
    if (this._bounds && this._fitIntoBounds) {
      let top, left, bottom, right;
      let bounds;
      // If we are dragging the dialog, use the drag coordinates to position the dialog.
      if (this._dragCoords && this._dragOffset) {
        top = this._dragCoords.clientY + this._dragOffset.y;
        left = this._dragCoords.clientX + this._dragOffset.x;
        bounds = this._dragStartBounds;
      }
      // Otherwise, position the dialog in the center of _fitInto.
      // TODO: Should add a 'centerTo' option for cases where we don't want the dialog to be restrained to 'fitInto' element.
      else {
        top = this._fitIntoBounds.yMin + this._fitIntoBounds.height / 2 - this._bounds.height / 2;
        left = this._fitIntoBounds.xMin + this._fitIntoBounds.width / 2 - this._bounds.width / 2;
        bounds = this._bounds;
      }

      // Limit top and left such that the dialog never shrinks beyond minWidth and minHeight.
      top = Clamp(top, this._fitIntoBounds.yMin - (bounds.height - this.minHeight), this._fitIntoBounds.yMax - this.minHeight);
      left = Clamp(left, this._fitIntoBounds.xMin - (bounds.width - this.minWidth), this._fitIntoBounds.xMax - this.minWidth);

      // Store the target top and left values so we can calculate the offset when the user drags the dialog again.
      this._set_targetCoords({ x: left, y: top });

      // Calculate the maximum allowed height and width of the dialog.
      const maxWidth = this.maxWidth || Math.min(left + bounds.width - this._fitIntoBounds.xMin, this._fitIntoBounds.xMax - left);
      const maxHeight = this.maxHeight || Math.min(top + bounds.height - this._fitIntoBounds.yMin, this._fitIntoBounds.yMax - top);

      // Clamp the top and left values to not be less than the min fitIntoBounds before setting on the dialog.
      top = Clamp(top, this._fitIntoBounds.yMin);
      left = Clamp(left, this._fitIntoBounds.xMin);

      // Update the style of the dialog.
      this.style.top = top + 'px';
      this.style.left = left + 'px';
      this.style.maxWidth = maxWidth + 'px';
      this.style.maxHeight = maxHeight + 'px';
      this.style.minWidth = this.minWidth + 'px';
      this.style.minHeight = this.minHeight + 'px';
    }

    this._updateShadow();
  }
  _updateBounds(rect) {
    this._set_bounds(this._calcBounds(rect || this._rect));
  }
  _updateFitIntoBounds(rect) {
    this._set_fitIntoBounds(this._calcBounds(rect || this._fitIntoRect, { padding: this.padding }));
  }
  _updateFitInto() {
    if ((this.fitInto instanceof Element || this.fitInto == window) && this.fitInto != this._fitInto) {
      if (this.opened) {
        // Stop observing the current fit into element.
        if (this._fitInto instanceof Element) this._resizeObserver.unobserve(this._fitInto);
        // Default the rect.
        this._set_fitIntoRect(this._calcRect(this.fitInto));
        // Begin observing the new fit into element.
        if (this.fitInto instanceof Element) this._resizeObserver.observe(this.fitInto);
        else if (this.fitInto == window) window.addEventListener('resize', this._resizeHandler);
      }
      this._set_fitInto(this.fitInto || window);
    }
  }
  _updateKeydownHandler() {
    if (this.opened && !this.noCancelOnEscKey) {
      window.addEventListener('keydown', this._keydownHandler);
    } else {
      window.removeEventListener('keydown', this._keydownHandler);
    }
  }
  _updateShadow() {
    let scrollTop = this.$.body.scrollTop;
    let scrollBottom = this.$.body.scrollHeight - (scrollTop + this.$.body.offsetHeight);
    let scrollShadowHeight = this.$.scrollShadowTop.offsetHeight;
    let scrollShadowTopOpacity = Clamp(scrollTop, 0, scrollShadowHeight) / scrollShadowHeight;
    let scrollShadowBottomOpacity = Clamp(scrollBottom, 0, scrollShadowHeight) / scrollShadowHeight;
    this.$.scrollShadowTop.style.opacity = scrollShadowTopOpacity;
    this.$.scrollShadowBottom.style.opacity = scrollShadowBottomOpacity;
  }
  _updateTransition() {
    if (!this.initialized) return;
    const transition = [`transform ${this.transitionSpeed}s`, `opacity ${this.transitionSpeed}s`];
    if (this.dynamicResize || this._transitionAll) transition.push(`top ${this._dragCoords ? 0 : this.transitionSpeed}s`);
    if (this._transitionAll) transition.push(`left ${this.transitionSpeed}s,`);
    this.style.transition = transition.join();
  }
}

window.customElements.define('katapult-dialog-legacy', KatapultDialogLegacy);
